import React from "react";

export default class TncOneMonth extends React.Component{
  render(){
    return (
      <div className="row padding-10">
        <div className="col-sm-12 terms-cond">
          <div>
            {
              this.props.conditionalTC === true &&
              <span className="text-uppercase">{this.props.headline} - </span>
            }
            TERMS & CONDITIONS</div>
          <ul className="list-padding">
            <li>This is a binding contract with RP Data Pty Ltd t/a Cotality . It combines the commercial terms on this webpage (which will be provided to you as a Product Schedule) together with our <a className="terms-link" href="https://www.cotality.com/au/legal/terms-conditions" target="_blank" rel="noopener noreferrer">Cotality Licence Agreement</a> and <a className="terms-link" href="https://www.cotality.com/au/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>;</li>
            <li>If there is any inconsistency between the commercial terms on this webpage and the Cotality Licence Agreement, the commercial terms will take precedence to the extent of the inconsistency.</li>
            <li>Your {this.props.totalMonths} {this.props.totalMonths > 1 ? "months" : "month"} subscription will expire {this.props.totalDays} days after activation. At this time your access will be disconnected unless you enter into a new contract with us.</li>
          </ul>
        </div>
      </div>
    )
  }
}
